export default __webpack_public_path__ + "static/media/2734.c4f9ec36.svg";